export default `
varying vec3 modelPosition;
void main()	
{
    modelPosition = vec3(position.x,position.y,-position.z);
    gl_Position =  projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}
`;
